const test = (obj: any, callback: Function): any => {
  return Object.entries(obj).every(([key, value]) => {
    if (
      key === 'id' ||
      key === 'type' ||
      key === 'userStartDay' ||
      key === 'userEndDay' ||
      key === 'showType' ||
      key === 'secretId'
    ) {
      return true
    }
    if (typeof value === 'object' && value !== null) {
      return test(value, callback)
    }
    if (Array.isArray(value)) {
      return value.every((element: any) => {
        return test(element, callback)
      })
    } else return callback(value)
  })
}

export const isAllFalseValue = (obj: object): boolean => {
  return test(obj, (value: any) => !value)
}
export const isAllTrueValue =  (obj: object): boolean => {
  return test(obj, (value: any) => value)
}

export const checkEmail = (email:string):boolean => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(email);

}

export const timeformatter = (date: Date) => {
  const today = new Date()

  const month = (date.getMonth() + 1) || '--'
  const day = date.getDate() || '--'
  const year = date.getFullYear() || '--'

  const hour = String(date.getHours()).padStart(2, '0') || '--'; // Ensure two digits
  const min = String(date.getMinutes()).padStart(2, '0')|| '--'; // Ensure two digits

  if (today.getMonth() + 1 === month && today.getDate() === day) {
    return hour + ':' + min;
  }
  if (today.getFullYear() === year) {
    return day + '/' + month+"\t"+ hour + ':' + min;
  }
  return day + '/' + month + '/' + year+"\t"+ hour + ':' + min;

}